import { TransferState, makeStateKey } from "@angular/platform-browser";
import { Inject, Injectable, NgZone } from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import { Observable, of, tap } from "rxjs";
import * as memoryCache from "memory-cache";
import { Environment, ENVIRONMENT } from '@nx-averycom/environment';

@Injectable({
  providedIn: 'root'
})
export class BrowserStateInterceptor implements HttpInterceptor {

  constructor(@Inject(ENVIRONMENT) private env: Environment, private transferState: TransferState, private ngZone: NgZone) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method !== 'GET' || req.urlWithParams.includes(this.env.dpo)) {
      return next.handle(req)
    }
    const storedResponse: string|null = this.transferState.get(makeStateKey(req.urlWithParams), null);

    if (storedResponse) {
      const response = new HttpResponse({body: storedResponse, status: 200});
      return of(response)
    }
    return next.handle(req).pipe(
      tap(event => {

        if (event instanceof HttpResponse) {
          this.transferState.set(makeStateKey(req.urlWithParams), event.body)
          this.ngZone.runOutsideAngular(() => {
            memoryCache.put(req.urlWithParams, event.body, 6000*5);
          });
        }
      })
    );
  }
}
